if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    // hide, show, or toggle
    const show = function (elem) {
        let getHeight = function () {
            elem.style.display = 'block';
            let height = elem.scrollHeight + 'px';
            elem.style.display = '';
            return height;
        };
        let height = getHeight(); // get element height
        elem.classList.add('appear');
        elem.style.height = height; // update the max-height
        window.setTimeout(function () {
            elem.style.height = '';
        }, 350);
    };
    const hide = function (elem) {
        elem.style.height = elem.scrollHeight + 'px';
        window.setTimeout(function () {
            elem.style.height = '0';
        }, 1);
        window.setTimeout(function () {
            elem.classList.remove('appear');
        }, 350);
    };
    const toggle = function (elem) {
        if (elem.classList.contains('appear')) {
            hide(elem);
            return;
        }
        show(elem);
    };

    //toggle more details
    document.addEventListener('click', function (event) {
        if (!event.target.classList.contains('toggle-btn-js')) return;
        event.preventDefault();
        if (event.target.classList.contains('active')) {
            event.target.classList.remove('active');
        } else {
            event.target.classList.add('active');
        }

        let content = document.querySelector(event.target.hash);
        if (!content) return;
        toggle(content);
    }, false);


    $('.sym-slides').slick();

    $(document).ready(function () {
        $('.map-section-home ul.pins li').click(function() {
            $('.map-section-home ul.pins li').removeClass('active');
            $(this).addClass('active');
            $('.each-location').hide();
            $('#each-location'+$(this).attr('target')).fadeIn();
        });

        $(".text-animate-js").html(function(index, html) {
          return html.replace(/\S/g, '<span class="each-letter hide-object">$&</span>');
        });
    });

})();